
import { Navbar } from '@/components/Navbar';
import { RansomwareFeed } from '@/components/RansomwareFeed';
import { Footer } from '@/components/Footer';
import { useLanguage } from '@/hooks/useLanguage';
import { Helmet } from 'react-helmet';

const Ransomware = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>{t('ransomware.title')} | Cybermonit</title>
      </Helmet>
      <Navbar />
      <main className="flex-grow">
        <RansomwareFeed />
      </main>
      <Footer />
    </div>
  );
};

export default Ransomware;
